/**
* @description
* # name controller --> indicatorsListController
* # As Controller --> indicatorsList
* brief comment controller shows the view for the main page of assignTimeRange
*/

export default class indicatorsListController {
	constructor($scope,indicatorsServices,learningObjetivesServices,ngNotify,UserInfoConstant,$state,$filter,) {
		this.$scope = $scope;
		this.ngNotify = ngNotify;
		this.$state = $state;
		this.services = indicatorsServices.services;
		this.learningObjetivesServices = learningObjetivesServices.services;
		this.buttonActions = true
		this.$scope.grid = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$translate = $filter('translate')
		this.conceptId = 0
		this.$scope.learningObjetiveSelect = null
		

		$scope.UserInfoConstant = UserInfoConstant;
		$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.USER_ID = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});

	}

	init(){
		this.services.getIndicators({ concept_id: this.conceptId}).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.indicators = []
				this.indicatorsList = dataReturn.results;
				for (let i in this.indicatorsList){
					this.indicators.push({
						title: this.indicatorsList[i].ds_name,
						id_code: this.indicatorsList[i].id_code,
						id_core: this.indicatorsList[i].learning_objective.core.id_code,
						id_concept: this.indicatorsList[i].id_concept,
						cod: this.indicatorsList[i].ds_code,
						learningObjetiveName: this.indicatorsList[i].learning_objective ? this.indicatorsList[i].learning_objective.ds_name : null,
						learningObjetiveCode: this.indicatorsList[i].learning_objective ? this.indicatorsList[i].learning_objective.ds_code : null,
						coreName: this.indicatorsList[i].learning_objective ? this.indicatorsList[i].learning_objective.core.ds_name : null,
						badges: [
							{
								label: ( (this.indicatorsList[i].is_active === true) ? this.$translate('ACTIVE') : this.$translate('INACTIVE')),
								bg: ( (this.indicatorsList[i].is_active === true) ? "bg-success" : "bg-dark" ),
								icon: "mdi-check"
							}
						]
					})
				}
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getLearningObjetive(params){
		this.learningObjetivesServices.getLearningObjetives(params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.objectKey= {}
				this.learningObjetivesList = dataReturn.results
				this.learningObjetivesList.map((object) => {
					this.objectKey[object.id_code] = object.ds_name
				})
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	onClick(item){
		this.indicatorId=item.id_code;
		this.indicatorName=item.title;
		this.code=item.cod;
		const params = {
			// core_id : item.id_core ? item.id_core : false,
			level_id : item.id_level ? item.id_level : false,
			concept_id : item.id_concept ? item.id_concept : false
		}
		this.getLearningObjetive(params)
		this.getDetailsFunction({indicator_id:this.indicatorId});
		this.panelConfig = true
		this.buttonActions = false
	}

	getDetailsFunction(params){
		this.services.getIndicatorDetails(params).$promise.then((dataReturn) => {
			if(dataReturn.results && Object.keys(dataReturn.results).length === 0){
				this.ngNotify.set('registro seleccionado no tiene registros','warn');

			}else{
				this.indicator = dataReturn.results;
				this.$scope.learningObjetiveSelect = this.indicator.id_learning_objective
				this.$scope.learningObjetiveName = this.indicator.learning_objective.ds_name
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})

	}

	selectChanged(learningObjetiveSelect){
		this.$scope.learningObjetiveName = this.objectKey[learningObjetiveSelect]

	}

	edit(){
		this.$scope.editSave = true;
		this.$scope.edit = false;
		this.$scope.titleList = false;
		this.$scope.titleEdit = true;
		this.$scope.isDisabled = false;
	}

	cancelEdit(){
		this.$scope.editSave = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$scope.titleEdit = false;
		this.getDetailsFunction({indicator_id:this.indicatorId});
		
	}

	saveEdit(){
		if(this.indicatorName === null || this.indicatorName === '') {
			this.ngNotify.set('Indique nombre','warn')
			return
		}

		if(this.code === null || this.code === '') {
			this.ngNotify.set('Indique código','warn')
			return
		}

		if(this.$scope.learningObjetiveSelect === null) {
			this.ngNotify.set('Seleccione un Ambito','warn')
			return
		}
		
		const params = {
			indicator_id: this.indicatorId,
			name: this.indicatorName,
			code: this.code,
			user_id: this.USER_ID,
			learning_objetive_id: this.$scope.learningObjetiveSelect
		}

		this.services.updateIndicators(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha modificado de manera correcta el Indicador','success');
				this.$state.go(this.$state.current, {}, {reload: true});
				this.$scope.edit = true;
				this.$scope.editSave = false;
				this.$scope.titleList = true;
				this.$scope.titleEdit = false;

			}else{
				if (dataReturn.isUniqueViolation) {
					this.ngNotify.set('Nombre de indicador se repite','error');
				}
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Nombre de indicador ya existe','error');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})

	}

	toggleList(isHide) {
		this.$scope.toggle = isHide
	}
}
indicatorsListController.$inject=['$scope', 'indicatorsServices', 'learningObjetivesServices', 'ngNotify','UserInfoConstant','$state','$filter']


// WEBPACK FOOTER //
// ./src/app/admin-panel/indicators/list/indicatorsListController.js